import React, { useState, useEffect } from "react";
import {
    Paper,
    Typography,
    makeStyles,
    TextField,
    Grid,
    FormControl,
    InputLabel,
    Select,
    Icon,
    MenuItem,
    IconButton,
    Button,
    Divider,
    darken,
    Backdrop,
    ButtonGroup,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import clsx from "clsx";
import Feedback from "../../atoms/Feedback";
import { getVISAs, getVISA } from "../../../actions/travelActions/visaActions";
import { getUsersList, getProfile } from "../../../actions/userActions";
import { customersArray } from "../../../utils";
import ItineraryModal from "./modals/ItineraryModal";

// Head of Division
import ApproveVisa from "./modals/ApproveVisa";
import RejectVisa from "./modals/RejectVisa";

// Services Division
import AcceptVisa from "./modals/AcceptVisa";
import DeclineVisa from "./modals/DeclineVisa";

const useStyles = makeStyles((theme) => ({
    title: {
        display: "block",
        fontSize: 16,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
        fontWeight: "bold",
    },
    title2: {
        display: "block",
        fontSize: 14,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontWeight: "bold",
        fontFamily: "Rubik",
        marginBottom: 10
    },
    title3: {
        display: "block",
        fontSize: 12,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
        fontWeight: "bold"
    },
    appBar: {
        zIndex: 9000,
    },
    container: {
        marginTop: theme.spacing(6),
        padding: theme.spacing(6),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
        },
    },
    paper: {
        padding: theme.spacing(2),
        marginBottom: 20,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
        },
    },
    paper1: {
        padding: theme.spacing(2),
        marginBottom: 20,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
        },
        background: theme.palette.type === "light" ? darken("#fff", 0.15) : darken("#fff", 0.80),
    },
    paper0: {
        padding: theme.spacing(2),
        marginBottom: 20,
        paddingBottom: 0,
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
        },
        background: theme.palette.type === "light" ? darken("#fff", 0.05) : darken("#fff", 0.80),
    },
    option: {
        fontSize: 15,
        "& > span": {
            marginRight: 10,
            fontSize: 18,
        },
    },
    textField: {
        marginBottom: theme.spacing(3),
    },
    paper2: {
        padding: "2px 20px 2px 5px",
        width: "60%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        marginBottom: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1),
            width: "100%",
        },
        "&:nth-of-type(2n)": {
            color: theme.palette.background.paper,
            backgroundColor: theme.palette.primary.main,
        },
    },
    dialogContent: {
        [theme.breakpoints.down("sm")]: {
            padding: "8px 14px",
        },
    },
    tabPanel: {
        padding: 14,
    },
    divider: {
        marginBottom: 10,
    },
    divider2: {
        height: 28,
        margin: 4,
    },
    total: {
        marginTop: 40,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
    warningInfo: {
        color: "#f5f5f5",
        background: "#f44336",
        padding: 20,
        marginBottom: 20,
        marginRight: 10,
        "& > *": {
            fontWeight: 900,
        },
    },
    form: {
        marginTop: 20,
    },
    grid: {
        marginBottom: 20,
    },
    input: {
        border: "1px solid #bdbdbd",
        padding: theme.spacing(2),
        borderRadius: 3,
    },

    btnWrapper: {
        textAlign: "center",
    },

    saveBtn: {
        fontFamily: "Rubik",
        letterSpacing: 2.5,
        margin: "30px 0",
        padding: theme.spacing(2),
        width: 200,
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    saveBtn2: {
        fontFamily: "Rubik",
        letterSpacing: 2.5,
        margin: "30px 0",
        padding: theme.spacing(2),
        width: 200,
        background: "#388e3c",
        color: "#fff",
        "&:hover": {
            background: darken("#388e3c", 0.15),
        },
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    backBtn: {
        letterSpacing: 2.5,
        padding: theme.spacing(1.2),
        paddingLeft: 20,
        paddingRight: 20,
    },
    status: {
        width: "fit-content",
        color: "#979292",
        padding: 6,
        background: "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    statusTitle: {
        color: "#b5b5b5",
        fontSize: "0.75rem",
    },
    statusTitle2: {
        color: "#fff",
        fontSize: "0.75rem",
        paddingLeft: 10,
        paddingRight: 10,
    },
    statusDarkGreen: {
        color: "#fff",
        backgroundColor: "#4caf50",
    },
    statusGreen: {
        color: "#fff",
        backgroundColor: "#1de9b6",
    },
    statusYellow: {
        color: "#fbc02d",
        backgroundColor: "#fbc02d",
    },
    statusRed: {
        color: "#fff",
        backgroundColor: "#ef5350",
    },
    statusOrange: {
        color: "#fff",
        backgroundColor: "#ff9800",
    },
    embed: {
        width: "100%",
        height: 100,
        objectFit: "contain",
        objectPosition: "center",
        marginRight: 5,
        cursor: "pointer",
        transition: "all 300ms ease-in-out",
        zIndex: 1,
        "&:hover": {
            transform: "scale(2.5)",
            zIndex: 1000000000000,
        },
    },
    audit: {
        padding: 10,
        fontFamily: "Rubik",
        fontSize: 10,
        width: "fit-content",
        textTransform: "uppercase",
        letterSpacing: 1.5,
        [theme.breakpoints.down("sm")]: {
            fontSize: 9,
        },
    },
    auditTitle: {
        padding: 10,
        // background: theme.palette.grey[600],
        color: theme.palette.type === "light" ? theme.palette.grey[600] : "#cccccc",
        fontFamily: "Rubik",
        fontSize: 10,
        fontWeight: "bold",
        width: "fit-content",
        textTransform: "uppercase",
        letterSpacing: 1.5,
        [theme.breakpoints.down("sm")]: {
            fontSize: 9,
        },
    },
    auditContainer: {
        width: "100%",
        display: "flex",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
    small: {
        fontSize: 11,
        lineHeight: 1.5,
        letterSpacing: 1.5,
        fontFamily: "Rubik",
        display: "block",
        color: theme.palette.type === "dark" && "#cccccc",
    },
    link: {
        display: "block",
        color: theme.palette.type === "dark" && "#cccccc",
    },
    centered: {
        textAlign: "center",
    },
    paperBlack: {
        color: "#f5f5f5",
        // background: "#3c3737",
        background: theme.palette.grey.A400,
        marginTop: 10,
        marginBottom: 10,
        padding: 5,
        textAlign: "center",
        maxWidth: 400,
        marginLeft: "auto",
        marginRight: "auto",
    },
    info2: {
        marginBottom: 20,
        fontWeight: 500,
    },
}));

const INIT_STATE = {
    employee: "",
    employeeName:"",
    employeeId:"",
    division: "",
    divisionName:"",
    userType: "",
    forSomeoneElse: "",
    applicant: null,
    travelPurpose:"",
    purposeOther:"",
    customer:"",
    projectCode:"",
    projectDescription:"",
    projectAsset:"",
    projectAddedDesc:"",
    visaType:"",
    visaStatus:"",
    attachments: [],
};

const ViewAccommodation = () => {
    const classes = useStyles();
    const { id } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const [state, setState] = useState(INIT_STATE);
    const { loading, error, visa } = useSelector((state) => state.visa);
    const [openApprove, setOpenApprove] = useState(false);
    const [openReject, setOpenReject] = useState(false);
    const [openAccept, setOpenAccept] = useState(false);
    const [openDecline, setOpenDecline] = useState(false);
    const { profile } = useSelector((state) => state.user);
    const [theUrl, setTheUrl] = useState("");
    const [openDoc, setOpenDoc] = useState(false);
        
    const [feed, setFeed] = useState({
        loading: false,
        open: false,
        message: "",
        success: false,
    });

    useEffect(() => {
        if (error && error !== null) {
            setFeed((prev) => ({
                loading: false,
                open: !prev.open,
                message: error,
                success: false,
            }));
        }
    }, [error]);

    useEffect(() => {
        dispatch(getVISAs());
        dispatch(getVISA(id));
        dispatch(getProfile());
        dispatch(getUsersList())
    }, [dispatch, id]);

    useEffect(() => {
        setState((prev) => ({
            ...prev,
            employee: (visa && visa.employee) || "",
            employeeName: (visa && visa.employee?.userName) || "",
            employeeId: (visa && visa.employee?.employeeId) || "",
            requestDate: (visa && visa.requestDate) || moment().toDate(),
            division: (visa && visa.division) || "",
            divisionName: (visa && visa.division?.name) || "",

            userType: (visa && visa.userType) || "",
            forSomeoneElse: (visa && visa.forSomeoneElse) || "",
            applicant: (visa && visa.applicant) || null,
            travelPurpose: (visa && visa.travelPurpose) || "",
            purposeOther: (visa && visa.purposeOther) || "",
            customer: (visa && visa.customer) || "",
            projectCode: (visa && visa.projectCode) || "",
            projectDescription: (visa && visa.projectDescription) || "",
            projectAsset: (visa && visa.projectAsset) || "",
            projectAddedDesc: (visa && visa.projectAddedDesc) || "",
            visaType: (visa && visa.visaType) || "",
            visaStatus: (visa && visa.visaStatus) || "",
            attachments: (visa && visa.attachments) || [],
            
            status: (visa && visa.status) || "",
            documentNo: (visa && visa.documentNo) || "",

            createdBy: (visa && visa.createdBy) || "",
            createdAt: (visa && visa.createdAt) || "",

            submittedBy: (visa && visa.submittedBy) || "",
            submittedAt: (visa && visa.submittedAt) || "",

            approvedBy: (visa && visa.approvedBy) || "",
            approvedAt: (visa && visa.approvedAt) || "",
            approveComment: (visa && visa.approveComment) || "",
            
            rejectedBy: (visa && visa.rejectedBy) || "",
            rejectedAt: (visa && visa.rejectedAt) || "",
            rejectComment: (visa && visa.rejectComment) || "",

            acceptedBy: (visa && visa.acceptedBy) || "",
            acceptedAt: (visa && visa.acceptedAt) || "",
            acceptComment: (visa && visa.acceptComment) || "",

            declinedBy: (visa && visa.declinedBy) || "",
            declinedAt: (visa && visa.declinedAt) || "",
            declineComment: (visa && visa.declineComment) || "",

        }));
    }, [visa]);

    const handleCloseFeed = () => {
        setFeed((prevState) => ({ ...prevState, open: false }));
    };

    // head of subdivision
    const handleOpenApprove = () => {
        setOpenApprove(true);
    };
    const handleCloseApprove = () => {
        setOpenApprove(false);
    };
    const handleOpenReject = () => {
        setOpenReject(true);
    };
    const handleCloseReject = () => {
        setOpenReject(false);
    };

    // services
    const handleOpenAccept = () => {
        setOpenAccept(true);
    };
    const handleCloseAccept = () => {
        setOpenAccept(false);
    };
    const handleOpenDecline = () => {
        setOpenDecline(true);
    };
    const handleCloseDecline = () => {
        setOpenDecline(false);
    };
    const handleOpenDoc = (url) => {
        setTheUrl(null);
        if(url){
            setTheUrl(url);
            setOpenDoc(true);
        }
    };
    const handleCloseDoc = () => {
        setOpenDoc(false);
    };


    const isAdmin = profile
        ? profile && profile.groups && profile.groups.some((grp) => grp.name === "admin")
        : false;
        
    const isDivManager = profile
        ? (profile && (profile?.id === state.division?.manager))
        : false;

    const isServices = profile
        ? profile && profile.division && ((profile?.division?.code === "SER"))
        : false;

    return (
        <div>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                {feed.success ? (
                    <Feedback
                        handleCloseFeed={handleCloseFeed}
                        open={feed.open}
                        severity="success"
                        message={feed.message}
                    />
                ) : (
                    <Feedback
                        handleCloseFeed={handleCloseFeed}
                        open={feed.open}
                        severity="error"
                        message={feed.message}
                    />
                )}

                {/* Head of subdivision */}
                <ApproveVisa {...{ openApprove, handleCloseApprove, id }} />
                <RejectVisa {...{ openReject, handleCloseReject, id }} />
    
                {/* Services */}
                <AcceptVisa {...{ openAccept, handleCloseAccept, id }} />
                <DeclineVisa {...{ openDecline, handleCloseDecline, id }} />

                <ItineraryModal {...{ openDoc, handleCloseDoc, docs: theUrl }} />

                <Typography variant="overline" className={classes.title}>
                    View Visa Application
                </Typography>

                <Grid container justify="space-between" alignItems="center" spacing={2} style={{ marginBottom: 20 }}>
                    <Grid item>
                        <Button
                            color="primary"
                            variant="contained"
                            className={classes.backBtn}
                            startIcon={<ArrowBackIosIcon />}
                            onClick={() => history.push("/travel/visa")}
                        >
                            Back
                        </Button>
                    </Grid>
                    <Grid item>
                        <Grid container alignItems="center">
                            <Grid item>
                                <Paper variant="outlined" className={classes.status}>
                                    <Typography variant="overline" className={classes.statusTitle}>
                                        Document No.
                                    </Typography>
                                    <Divider className={classes.divider2} orientation="vertical" />
                                    {loading ? "Loading..." : state.documentNo}
                                    
                                </Paper>
                            </Grid>
                            &nbsp;&nbsp;&nbsp;
                            <Grid item>
                                <Paper
                                    variant="outlined"
                                    className={clsx(
                                        state.status === "draft"
                                            ? classes.statusYellow
                                            : state.status === "submitted"
                                                ? classes.statusOrange
                                                : (state.status === "accepted" || state.status === "approved" || state.status === "confirmed" || state.status === "consented") ? classes.statusGreen
                                                    : (state.status === "issued" || state.status === "collected" || state.status === "transferred" || state.status === "returned" || state.status === "received" || state.status === "completed")
                                                        ? classes.statusDarkGreen
                                                        : classes.statusRed,
                                        classes.status
                                    )}
                                >
                                    <Typography variant="overline" className={classes.statusTitle2}>
                                        Status
                                    </Typography>
                                    <Divider className={classes.divider2} orientation="vertical" />
                                    <Typography variant="overline" className={classes.statusTitle2}>
                                        {loading ? "Loading..." : state.status}
                                    </Typography>
                                </Paper>
                            </Grid>
                        </Grid>                        
                    </Grid>
                </Grid>

                <Paper variant="outlined" square className={classes.paper}>
                    <Paper variant="outlined" square className={classes.paper0} >
                        <Grid container spacing={2} className={classes.grid}>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    label="Employee Name"
                                    name="employeeName"
                                    variant="outlined"
                                    fullWidth
                                    disabled
                                    value={(state.employeeName && state.employeeName) || ""}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    label="Employee ID"
                                    name="employeeId"
                                    variant="outlined"
                                    fullWidth
                                    disabled
                                    value={state.employeeId || ""}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <DatePicker
                                    className={classes.marginBottom}
                                    autoOk
                                    format="DD/MM/yyyy"
                                    views={["year", "month", "date"]}
                                    label="Date Created"
                                    fullWidth
                                    required
                                    name="requestDate"
                                    inputVariant="outlined"
                                    value={state.requestDate}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    label="Division/Unit"
                                    name="division"
                                    variant="outlined"
                                    fullWidth
                                    value={(state.division && state.divisionName) || ""}
                                    disabled
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth variant="outlined" required>
                                    <InputLabel>Are you filling on behalf of someone else?</InputLabel>
                                    <Select
                                        inputProps={{
                                            id: "forSomeoneElse",
                                            name: "forSomeoneElse",
                                        }}
                                        placeholder="Are you filling on behalf of someone else?"
                                        label="Are you filling on behalf of someone else?"
                                        value={state.forSomeoneElse || ""}
                                        disabled
                                    >
                                        <MenuItem disabled>Select Option</MenuItem>
                                        <MenuItem value="No">No</MenuItem>
                                        <MenuItem value="Yes">Yes</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                                        
                            {(state.forSomeoneElse === "Yes") && (<>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <InputLabel>External User / Internal User</InputLabel>
                                        <Select
                                            inputProps={{
                                                id: "userType",
                                                name: "userType",
                                            }}
                                            placeholder="External User / Internal User"
                                            label="External User / Internal User"
                                            value={state.userType || ""}
                                            disabled
                                        >
                                            <MenuItem disabled>Select Option</MenuItem>
                                            <MenuItem value="Internal">Internal User</MenuItem>
                                            <MenuItem value="External">External User</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </>)}
                        </Grid>
                    </Paper>

                    {(state.applicant && state.applicant?.name) && ( <> 
                        <Typography variant="overline" className={classes.title2}>
                            APPLICANT DETAILS
                        </Typography>

                        <Paper variant="outlined" square className={classes.paper0}>
                            <Grid container justify="center" alignItems="center" spacing={2} className={classes.grid}>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        variant="outlined"
                                        fullWidth
                                        required
                                        label="Applicant Name"
                                        name="name"
                                        value={state.applicant?.name || ""}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        variant="outlined"
                                        fullWidth
                                        required
                                        label="Applicant Email"
                                        name="email"
                                        type="email"
                                        value={state.applicant?.email || ""}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        variant="outlined"
                                        fullWidth
                                        required
                                        label="Applicant Phone Number"
                                        name="phoneNumber"
                                        value={state.applicant?.phoneNumber || ""}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        variant="outlined"
                                        fullWidth
                                        required
                                        label="Applicant ID"
                                        name="applicantId"
                                        value={state.applicant?.applicantId || ""}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <DatePicker
                                        autoOk
                                        format="DD/MM/yyyy"
                                        views={["year", "month", "date"]}
                                        label="Applicant Date of Birth"
                                        placeholder="Applicant Date of Birth"
                                        fullWidth
                                        inputVariant="outlined"
                                        value={state.applicant?.dateofbirth || new Date()}
                                        required
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12} md={9}></Grid>
                            </Grid>
                        </Paper>
                    </> )}

                    <Typography variant="overline" className={classes.title2}>
                        VISA DETAILS
                    </Typography>

                    <Paper variant="outlined" square className={classes.paper0}>
                        <Grid container spacing={2} className={classes.grid}>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth variant="outlined" required>
                                    <InputLabel>Purpose of Travel</InputLabel>
                                    <Select
                                        inputProps={{
                                            id: "travelPurpose",
                                            name: "travelPurpose",
                                        }}
                                        label="Purpose of Travel"
                                        placeholder="Purpose of Travel"
                                        value={state.travelPurpose || ""}
                                        disabled
                                    >
                                        <MenuItem disabled>Select Option</MenuItem>
                                        <MenuItem value="Vacation">Vacation</MenuItem>
                                        <MenuItem value="Training">Training</MenuItem>
                                        <MenuItem value="Seminar">Seminar</MenuItem>
                                        <MenuItem value="Conference">Conference</MenuItem>
                                        <MenuItem value="Project">Project</MenuItem>
                                        <MenuItem value="Others">Others</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            {(state.travelPurpose === "Others") && (
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        id="purposeOther"
                                        name="purposeOther"
                                        label="Travel Purpose Description"
                                        placeholder="Travel Purpose Description"
                                        value={state.purposeOther || ""}
                                        disabled
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>    
                            )}
                            {(state.travelPurpose === "Project") && ( <>
                                <Grid item xs={12} md={3}>
                                    <FormControl fullWidth variant="outlined" required>
                                        <InputLabel>Customer Name</InputLabel>
                                        <Select
                                            inputProps={{
                                                id: "customer",
                                                name: "customer",
                                            }}
                                            label="Customer"
                                            placeholder="Customer"
                                            value={state.customer || ""}
                                            disabled
                                        >
                                            {customersArray && customersArray.map((item, i) => (
                                            <MenuItem key={i} value={item.name}>
                                                {item.name}
                                            </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        id="projectCode"
                                        name="projectCode"
                                        placeholder="Project Code"
                                        label="Project Code"
                                        value={state.projectCode || ""}
                                        disabled
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        id="projectDescription"
                                        name="projectDescription"
                                        placeholder="Project Description"
                                        label="Project Description"
                                        value={state.projectDescription || ""}
                                        disabled
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        id="projectAsset"
                                        name="projectAsset"
                                        placeholder="Asset/Facilities"
                                        label="Asset/Facilities"
                                        value={state.projectAsset || ""}
                                        disabled
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        id="projectAddedDesc"
                                        name="projectAddedDesc"
                                        placeholder="Project Added Description"
                                        label="Project Added Description"
                                        value={state.projectAddedDesc || ""}
                                        disabled
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                            </>)}
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth variant="outlined" required>
                                    <InputLabel>Type of Visa</InputLabel>
                                    <Select
                                        inputProps={{
                                            id: "visaType",
                                            name: "visaType",
                                        }}
                                        label="Type of Visa"
                                        placeholder="Type of Visa"
                                        value={state.visaType || ""}
                                        disabled
                                    >
                                        <MenuItem disabled>Select Option</MenuItem>
                                        <MenuItem value="Visiting">Visiting</MenuItem>
                                        <MenuItem value="Business">Business</MenuItem>
                                        <MenuItem value="Residence Permit">Residence Permit</MenuItem>
                                        <MenuItem value="Subject to Regularization (STR)">Subject to Regularization (STR)</MenuItem>
                                        <MenuItem value="Temporary Work Permit (TWP)">Temporary Work Permit (TWP)</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth variant="outlined" required>
                                    <InputLabel>Visa Status</InputLabel>
                                    <Select
                                        inputProps={{
                                            id: "visaStatus",
                                            name: "visaStatus",
                                        }}
                                        label="Visa Status"
                                        placeholder="Visa Status"
                                        value={state.visaStatus || ""}
                                        disabled
                                    >
                                        <MenuItem value={state.visaStatus}>{state.visaStatus}</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Paper>

                    {state.attachments && state.attachments.length > 0 && (<>
                        
                    <Typography variant="overline" className={classes.title2}>
                        PASSPORT ATTACHMENTS
                    </Typography>

                    <Paper variant="outlined" square className={classes.paper0}>
                        <TableContainer>
                            <Table bordered="true" className={classes.table} aria-label="custom pagination table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>SN</TableCell>
                                        <TableCell>Name</TableCell>
                                        <TableCell>Passport Number</TableCell>
                                        <TableCell>Nationality</TableCell>
                                        <TableCell>Departure Date</TableCell>
                                        <TableCell>Arrival Date</TableCell>
                                        <TableCell>Application Country</TableCell>
                                        <TableCell>Passport Expiry Date</TableCell>
                                        <TableCell>Visiting Country</TableCell>
                                        <TableCell>Passport File</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {state.attachments && state.attachments.map((sitem, i) => (
                                        <TableRow key={i}>
                                            <TableCell component="th" scope="row">{i + 1}</TableCell>
                                            <TableCell component="th" scope="row">{sitem.name || ""}</TableCell>
                                            <TableCell component="th" scope="row">{sitem.passportNumber || ""}</TableCell>
                                            <TableCell component="th" scope="row">{sitem.nationality || ""}</TableCell>
                                            <TableCell component="th" scope="row">{sitem.departureDate || ""}</TableCell>
                                            <TableCell component="th" scope="row">{sitem.arrivalDate || ""}</TableCell>
                                            <TableCell component="th" scope="row">{sitem.applicationCountry || ""}</TableCell>
                                            <TableCell component="th" scope="row">{sitem.expiryDate || ""}</TableCell>
                                            <TableCell component="th" scope="row">{sitem.visitingCountry || ""}</TableCell>
                                            <TableCell component="th" scope="row">
                                                <IconButton
                                                    disabled={sitem.passport === null}
                                                    onClick={() => handleOpenDoc(sitem.passport)}
                                                >
                                                        <AttachFileIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper> 
                    
                    </>)}

                    <Grid container alignItems="center" wrap="nowrap" spacing={1} style={{ marginBottom: 5 }}>
                        <Grid item>
                            <Typography variant="overline" className={classes.title3}>
                                Audit Trail
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Icon className="fas fa-clipboard-list" color="disabled" />
                        </Grid>
                    </Grid>

                    <Paper variant="outlined" square className={classes.paper}>
                        <Grid container justify="space-between" alignItems="center" spacing={2}>
                            <Grid item xs={12} md={12}>
                                <Paper
                                    className={classes.auditContainer}
                                    component="div"
                                    elevation={1}
                                    variant="outlined"
                                    square
                                >
                                    <span className={classes.auditTitle}>Created By</span>
                                    <Divider orientation="vertical" flexItem />
                                    <span className={classes.audit}>{state.createdBy && state.createdBy.userName}</span>
                                    <Divider orientation="vertical" flexItem />
                                    <span className={classes.audit}>{state.createdAt}</span>
                                </Paper>
                            </Grid>
                            
                            <Grid item xs={12} md={12}>
                                <Paper
                                    className={classes.auditContainer}
                                    component="div"
                                    elevation={1}
                                    variant="outlined"
                                    square
                                >
                                    <span className={classes.auditTitle}>Submitted By</span>
                                    <Divider orientation="vertical" flexItem />
                                    <span className={classes.audit}>{state.submittedBy && state.submittedBy.userName}</span>
                                    <Divider orientation="vertical" flexItem />
                                    <span className={classes.audit}>{state.submittedAt}</span>
                                </Paper>
                            </Grid>

                            {(state.approvedAt && state.approvedBy) && (
                                <>
                                    <Grid item xs={12} md={12}>
                                        <Paper
                                            className={classes.auditContainer}
                                            component="div"
                                            elevation={1}
                                            variant="outlined"
                                            square
                                        >
                                            <span className={classes.auditTitle}>Approved By</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.approvedBy && state.approvedBy.userName}</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.approvedAt}</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.auditTitle}>Comment</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.approveComment}</span>
                                        </Paper>
                                    </Grid>
                                </>
                            )}
                            {(state.rejectedAt && state.rejectedBy) && (
                                <>
                                    <Grid item xs={12} md={12}>
                                        <Paper
                                            className={classes.auditContainer}
                                            component="div"
                                            elevation={1}
                                            variant="outlined"
                                            square
                                        >
                                            <span className={classes.auditTitle}>Rejected By</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.rejectedBy && state.rejectedBy.userName}</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.rejectedAt}</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.auditTitle}>Comment</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.rejectComment}</span>
                                        </Paper>
                                    </Grid>
                                </>
                            )}
                            {(state.acceptedAt && state.acceptedBy) && (
                                <>
                                    <Grid item xs={12} md={12}>
                                        <Paper
                                            className={classes.auditContainer}
                                            component="div"
                                            elevation={1}
                                            variant="outlined"
                                            square
                                        >
                                            <span className={classes.auditTitle}>Accepted By</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.acceptedBy && state.acceptedBy.userName}</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.acceptedAt}</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.auditTitle}>Comment</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.acceptComment}</span>
                                        </Paper>
                                    </Grid>
                                </>
                            )}
                            {(state.declinedAt && state.declinedBy) && (
                                <>
                                    <Grid item xs={12} md={12}>
                                        <Paper
                                            className={classes.auditContainer}
                                            component="div"
                                            elevation={1}
                                            variant="outlined"
                                            square
                                        >
                                            <span className={classes.auditTitle}>Declined By</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.declinedBy && state.declinedBy.userName}</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.declinedAt}</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.auditTitle}>Comment</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.declineComment}</span>
                                        </Paper>
                                    </Grid>
                                </>
                            )}
                            {(state.reviewedAt && state.reviewedBy) && (
                                <>
                                    <Grid item xs={12} md={12}>
                                        <Paper
                                            className={classes.auditContainer}
                                            component="div"
                                            elevation={1}
                                            variant="outlined"
                                            square
                                        >
                                            <span className={classes.auditTitle}>Reviewed By</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.reviewedBy && state.reviewedBy.userName}</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.reviewedAt}</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.auditTitle}>Comment</span>
                                            <Divider orientation="vertical" flexItem />
                                            <span className={classes.audit}>{state.reviewComment}</span>
                                        </Paper>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    </Paper>

                    {/* ACTION BUTTONS */}
                    {(isDivManager || isAdmin) && state.status === "submitted" ? (
                        <Grid container justify="center">
                            <Grid item>
                                <div className={classes.centered}>
                                    <Paper className={classes.paperBlack}>
                                        <HelpOutlineIcon fontSize="large" />
                                        <Typography placeholder="Info" className={classes.info2}>
                                            This Visa Application approval or rejection is to be done by the Head of the 
                                            Requesting Division/Unit.
                                        </Typography>
                                    </Paper>
                                </div>
                                <ButtonGroup>
                                    <Button
                                        onClick={handleOpenApprove}
                                        className={classes.saveBtn2}
                                        variant="contained"
                                    >
                                        Approve
                                    </Button>
                                    <Button
                                        onClick={handleOpenReject}
                                        className={classes.saveBtn}
                                        color="secondary"
                                        variant="contained"
                                    >
                                        Reject
                                    </Button>
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                    ) : null}

                    {(isServices || isAdmin) && state.status === "approved" ? (
                        <Grid container justify="center">
                            <Grid item>
                                <div className={classes.centered}>
                                    <Paper className={classes.paperBlack}>
                                        <HelpOutlineIcon fontSize="large" />
                                        <Typography placeholder="Info" className={classes.info2}>
                                            This Visa Application acceptance or decline is to be done by anyone in the Services Division.
                                        </Typography>
                                    </Paper>
                                </div>
                                <ButtonGroup>
                                    <Button
                                        onClick={handleOpenAccept}
                                        className={classes.saveBtn2}
                                        variant="contained"
                                    >
                                        Accept
                                    </Button>
                                    <Button
                                        onClick={handleOpenDecline}
                                        className={classes.saveBtn}
                                        color="secondary"
                                        variant="contained"
                                    >
                                        Decline
                                    </Button>
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                    ) : null}
                </Paper>

            </MuiPickersUtilsProvider>

            <Backdrop className={classes.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};

export default ViewAccommodation;
